module.exports = __webpack_public_path__ + "static/media/luz.b0bb0fe5.png";